/**
 * Created by JIA on 2020/4/30.
 */
import React, { Component } from "react";
import _ from "lodash";
import PropTypes from "prop-types";
import { Animated, Easing, TouchableOpacity, View } from "react-native";
import { Button, Text } from "native-base";
import { withTranslation } from "react-i18next";
import Icon from "react-native-vector-icons/Ionicons";
import Emoji from "react-native-vector-icons/Entypo";
import Video from "react-native-video";
import { Surface, Shape, Path } from "@react-native-community/art";

import SpeechRecognitionService from "../../components/customModule/speechRecognition/SpeechRecognition";
import SpeechReivewService from "../../components/customModule/speechRecognition/SpeechReview";
import { AppStyles } from "../../theme/index";
import UIDs from "../../UIDs";
import Constants from "../../config/Constants";

import UnitStyle from "../../screens/course/units/UnitStyle";
import Letter from "./Letter";
import { t } from "../../i18n/index";
import * as Helper from "../../utils/Helper";
import * as ErrorHelper from "../../utils/ErrorHelper";
import * as WebHelper from "../../utils/WebHelper";

import Dimensions from "react-native-web-dimension-helper";
import localStorageFileHelper from "../../../utils/LocalStorageFileHelper";
import { GetPlainTextFromSentenceForSpeechUse } from "../../utils/MarkTextHelper";

const uid = UIDs.components.ui.speechTestBox;

const ScreenWidth = Helper.getContainerSize().width;

//we just need a whole string for reference text
const getReferenceText = chars => {
    return GetPlainTextFromSentenceForSpeechUse(chars.join(""));
};

class PlayingButton extends Component {
    _animation = null;
    constructor(props) {
        super(props);

        this.state = {
            fadeValue: new Animated.Value(0.8),
        };
    }

    componentDidMount() {
        this.startAnimation();
    }

    startAnimation() {
        if (this.props.audioIsPlaying) {
            this._animation = Animated.timing(this.state.fadeValue, { toValue: 0.2, duration: 1200 }).start(() => {
                this.setState({ fadeValue: new Animated.Value(0.8) }, () => {
                    this.startAnimation();
                });
            });
        }
    }

    componentWillUnmount() {
        //stop animation when unmount
        // if (this._animation) {
        //     try {
        //         this._animation.stop();
        //     } catch (ex) {}
        // }
    }

    render() {
        return (
            <Animated.View style={[{ opacity: this.state.fadeValue }]}>
                <Button transparent style={[styles.playBtn, this.props.styles]} onPress={this.props.onHandlerPress}>
                    <Icon size={28} name="md-square" color="#fff" />
                </Button>
            </Animated.View>
        );
    }
}

class WavingLine extends Component {
    static propTypes = {
        volume: PropTypes.number,
        height: PropTypes.number,
        width: PropTypes.number,
        color: PropTypes.string,
        title: PropTypes.string,
        onEnd: PropTypes.func,
    };

    static defaultProps = {
        volume: 0,
        height: 75,
        width: ScreenWidth,
        color: "#66bb6a",
        title: t("Click Wave To End"),
        onEnd: null,
    };

    constructor(props) {
        super(props);

        this.state = {
            oriValue: new Animated.Value(1.0),
            offset: 0,
        };

        this.localVars = {
            waveLength: 0.5,
            xScale: 1 / 30.0,
            yScale: 20,
            myInterval: null,
        };
    }

    componentDidMount() {
        this._startAnimation();

        this._waving();
    }

    componentWillUnmount() {
        if (this.localVars.myInterval) {
            clearInterval(this.localVars.myInterval);
            this.localVars.myInterval = null;
        }
    }

    _waving = () => {
        this.localVars.myInterval = setInterval(() => {
            let { offset } = this.state;
            offset -= 0.8;
            if (offset < -60 * Math.PI * 2) {
                offset = 0;
            }
            this.setState({
                offset,
            });
        }, 100);
    };

    _getBezierPath = () => {
        const { width, height, volume } = this.props;
        const { waveLength, xScale, yScale } = this.localVars;
        const { offset } = this.state;
        const { PI, sin } = Math;

        const path = new Path();
        path.moveTo(0, height / 2); //start point
        // add points
        for (let x = 0; x < width; x += waveLength) {
            /* 假设 y = Asin（ωx+φ）+ C
            其中:
            A 表示振幅，也就是使用这个变量来调整波浪的最大的高度;
            ω 与周期相关，周期 T = 2 * pi / ω ，这个变量用来调整同宽度内显示的波浪的数量;
            φ 表示波浪横向的偏移，也就是使用这个变量来调整波浪的流动;
            C 表示波浪纵向偏移的位置。

            //waveMax 波动幅度
            //xScale x轴缩放
            //yScale y轴缩放
            //offset x轴偏移
            y = waveMax * yScale * sin(xScale * x + offset);

            //两边还要控制一下收敛回到x轴, 需要乘多个sin函数
            y = sin((PI/width) * x) * waveMax * (yScale * sin(xScale * x + offset)); */
            const y = sin((PI / width) * x) * (((volume * height) / (yScale * 100)) * waveLength) * (yScale * sin(xScale * x + offset)) + height / 2;
            path.curveTo(x, y);
        }
        path.curveTo(width, height / 2); //end point

        return path;
    };

    _startAnimation = () => {
        const { oriValue } = this.state;

        Animated.timing(oriValue, {
            toValue: 0,
            duration: 5000,
            easing: Easing.linear,
            useNativeDriver: false,
        }).start(() => {
            this._startAnimation();
        });
    };

    render() {
        const { width, height, color } = this.props;
        const path = this._getBezierPath();

        return (
            <View style={{ justifyContent: "flex-start", alignItems: "flex-start", width: Helper.getContainerSize().width }}>
                <Animated.View
                    style={{
                        height,
                        width,
                        left: this.state.oriValue,
                    }}>
                    <TouchableOpacity
                        disabled={!this.props.onEnd}
                        style={{ overflow: "hidden", width: width, height: height, justifyContent: "center", alignItems: "center" }}
                        onPress={() => {
                            this.props.onEnd && this.props.onEnd();
                        }}>
                        <Surface height={height} width={width}>
                            <Shape d={path} stroke={color} />
                        </Surface>
                    </TouchableOpacity>
                </Animated.View>
                {this.props.title ? <div style={{ width: "100%", textAlign: "center", fontSize: 17, color: "#888", zIndex: -1, position: "absolute" }}>{this.props.title}</div> : null}
            </View>
        );
    }
}

/**
 * generate a full wav path for every record.
 *  just use the time stamp is good, it is ms level
 * @returns {string}
 */
const generateTempWavFile = (isMp3) => {
    const currentMS = new Date().getTime();
    const suffix = isMp3 ? 'mp3' : 'wav';
    return `${Constants.LOCAL_FILE_STORAGE.TEMP_PATH}recorded/audio-${currentMS}.${suffix}`;
};

class SpeechTestBox extends Component {
    localVars = {
        localSpeechService: SpeechRecognitionService,
    };
    constructor(props) {
        super(props);

        this.state = {
            currentState: 0, // 0 not start, 1 recording, 2 loading result, 3 result, 4 error in recognize
            prepareRecording: false,
            errorMessage: "",
            response: {},
            lastWavPath: null,
            lastWavPathUri: null, // file:// with empty last part seems casue crash on ios, so when empty we use a empty uri
            paused: true,
            lastGenerateWavFile: null, //remember your last record file here
            volume: 0,
            speechServiceReady: false,
        };
    }

    componentDidMount() {
        // SpeechRecognitionService.getLastWavFilePath(file => {
        //     this.setState({ lastWavPath: file });
        // });
        let config = {
            encodeFormat: this.props.encodeFormat,
            enableSpeechRecognize: this.props.enableSpeechRecognize,
            lang: this.props.language=== "en" ? Constants.SPEECH_LANG.en : Constants.SPEECH_LANG.zh,
            rejectPermissionCallback: () => {
                if (this.props.rejectPermissionCallback && _.isFunction(this.props.rejectPermissionCallback)) {
                    this.props.rejectPermissionCallback();
                }
            },
            initFailCallback: (title, content, buttonText) => {
                if (this.props.initFailCallback && _.isFunction(this.props.initFailCallback)) {
                    this.props.initFailCallback(title, content, buttonText);
                }
            },
            backgroundStopRecordCallback: () => {
                //如果在整题录音时，切换到其他app(易度app退到后台)；此时应该取消录音，返回到题目页
                if (this.state.currentState === 1) {
                    if (this.props.backgroundStopRecordCallback && _.isFunction(this.props.backgroundStopRecordCallback)) {
                        this.props.backgroundStopRecordCallback(this._onEndRecordPress);
                    }
                }
            },
        };
        if (!_.isUndefined(this.props.serviceType)) {
            config.serviceType = this.props.serviceType;
        }
        if (this.props.enableSpeechReview) {
            config.forReview = this.props.enableSpeechReview;
            this.localVars.localSpeechService = SpeechReivewService;
        }
        this.localVars.localSpeechService.initWithoutKey(config).then(() => {
            this.localVars.localSpeechService.addEventListener("onStatChange", event => {
                //console.log(event);
            });

            this.localVars.localSpeechService.addEventListener("onVolumeChange", event => {
                //console.log(event);
                const { volume, currentState } = this.state;
                if (event.Volume && event.Volume !== volume && currentState === 1) {
                    this.setState({ volume: event.Volume });
                }
            });

            this.localVars.localSpeechService.setReferenceText("");
            this.setState({ speechServiceReady: true });
        });
    }

    componentWillUnmount() {
        if (this._recordingTimeout) {
            clearTimeout(this._recordingTimeout);
            delete this._recordingTimeout;
        }

        this.localVars.localSpeechService.stopRecognize();
        this.localVars.localSpeechService.removeAllListeners();
        this.localVars.localSpeechService.destroy();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {}

    render() {
        //const { words } = this.props.data;

        const { paused, currentState, prepareRecording, errorMessage, response, volume } = this.state;
        const { audioIsPlaying: playing, showLeftPlayButton, showRecordButton, showRightPlayButton, enableSpeechRecognize, showScoreInside } = this.props;
        console.log(response);

        let playUri = this.state.lastWavPathUri;
        if (WebHelper.isSafari()) {
            // NOTE: safari不支持播放blob url
            if (this.props.lastRemoteFile) {
                playUri = Helper.convertToAbsoluteUrl(this.props.lastRemoteFile);
            }
        }

        const hasAudioFile = this.props.initUserWavPath && !_.isEmpty(this.props.initUserWavPath);
        const playDisabled = playing || (currentState === 0 && !(this.props.initUserWavPath && !_.isEmpty(this.props.initUserWavPath)));
        const micDisabled = playing || !paused || !this.state.speechServiceReady || this.props.disableRecord;
        return (
            <View style={[styles.container, AppStyles.centerAligned, this.props.containerStyle]}>
                {(currentState === 1) && (!prepareRecording) ? (
                    <TouchableOpacity style={{ flex: 1 }} onPress={this._onEndRecordPress}>
                        <View
                            style={{
                                flex: 1,
                                flexDirection: "column",
                                alignItems: "center",
                                justifyContent: "center",
                                // paddingTop: this.props.recordingTitle ? 15 : undefined,
                                backgroundColor: this.props.recordingBgColor || undefined,
                            }}>
                            {this.props.recordingTitle}
                            <WavingLine
                                height={this.props.recordingTitle ? 48 : 75}
                                width={ScreenWidth}
                                color="#66bb6a"
                                volume={volume}
                                title={this.props.recordingTitle ? "" : undefined}
                                color={this.props.wavingLineColor || undefined}
                            />
                        </View>
                    </TouchableOpacity>
                ) : (
                    <View style={[AppStyles.row, AppStyles.centerAligned, { marginTop: 15 }]}>
                        <View style={[styles.btnContainer, { flex: showRecordButton ? 1 : showLeftPlayButton ? 1 : 0, marginRight: 10 }]}>
                            {showLeftPlayButton ? (
                                !paused ? (
                                    <PlayingButton styles={currentState > 0 ? this.getBackgroundColor(response, currentState) : {}} audioIsPlaying={!paused} onHandlerPress={this._onStopMp3} />
                                ) : (
                                    <Button
                                        transparent
                                        style={[(playDisabled && !hasAudioFile) ? styles.playBtnDisabled : styles.playBtn, showScoreInside && currentState > 0 ? this.getBackgroundColor(response, currentState) : {}]}
                                        onPress={this._onPlayMp3Press}
                                        disabled={playDisabled || this.props.disableRecord}>
                                        {showScoreInside && enableSpeechRecognize && currentState > 0 ? (
                                            currentState === 4 || response.accuracyScore < 60 ? (
                                                <Emoji size={48} name="emoji-sad" color="#fff" />
                                            ) : (
                                                <Icon style={styles.score} color="#fff">
                                                    {_.round(response.accuracyScore)}
                                                </Icon>
                                            )
                                        ) : (
                                            <Icon size={36} name="ios-play" color="#fff" style={{ marginLeft: 5 }} />
                                        )}
                                    </Button>
                                )
                            ) : null}
                        </View>
                        <View style={[styles.btnContainer, { flex: showRecordButton ? 1 : 0 }]}>
                            {showRecordButton ? (
                                <Button
                                    transparent
                                    style={showLeftPlayButton ? [styles.rerecordBtn, {backgroundColor: micDisabled ? "#ccc" : "#ffc000"}] : [styles.recordBtn, {backgroundColor: micDisabled ? "#ccc" : "#66bb6a"}]}
                                    onPress={this._onStartRecordPress}
                                    disabled={micDisabled}>
                                    <Icon size={48} name="ios-mic" color="#fff" />
                                </Button>
                            ) : null}
                            {showRecordButton && showLeftPlayButton ? <Text style={{ color: "#666", fontSize: 13 }}>{this.props.t("rerecord")}</Text> : null}
                        </View>
                        <View style={[styles.btnContainer, { flex: showRecordButton ? 1 : showRightPlayButton ? 1 : 0 }]}>
                            {showRightPlayButton ? (
                                playing ? (
                                    <PlayingButton styles={styles.passed} audioIsPlaying={playing} onHandlerPress={this._onStopAudio} />
                                ) : (
                                    <Button transparent style={styles.playBtn} onPress={this._onPlayAudio} disabled={!paused}>
                                        <Icon size={40} name="ios-volume-high" style={{ marginLeft: 2 }} color="#fff" />
                                    </Button>
                                )
                            ) : null}
                        </View>
                    </View>
                )}
                <Video
                    audioOnly={true}
                    paused={paused}
                    ignoreSilentSwitch={"ignore"}
                    source={{ uri: playUri }} // Can be a URL or a local file.
                    volume={100}
                    ref={ref => {
                        this.player = ref;
                    }} // Store reference
                    onEnd={this._onStopMp3}
                    style={styles.backgroundVideo}
                />
                {prepareRecording ?
                 (<View
                      style={{ position: "absolute", zIndex: 10, left: 0, top: 0, right: 0, bottom: 0, backgroundColor: "rgba(0, 0, 0, 0)" }}
                  >
                  </View>) : null}
            </View>
        );
    }

    // renderScore = response => {
    //     if (response.passed) {
    //         if (response.accuracyScore > 90) {
    //             return this.props.t("Perfect", { score: response.accuracyScore });
    //         } else {
    //             return this.props.t("Good", { score: response.accuracyScore });
    //         }
    //     } else {
    //         return this.props.t("Bad", { wrongCount: response.wholeWordCount - response.passedWordCount, score: response.accuracyScore });
    //     }
    // };
    getBackgroundColor = (response, currentState) => {
        if (currentState === 4) {
            //bad recognize, return red
            return styles.bad;
        }
        //for not enable speech recognize, just return a success
        if (!this.props.enableSpeechRecognize) {
            return styles.passed;
        }

        if (response.passed) {
            return styles.passed;
        } else if (response.accuracyScore >= 60) {
            return styles.medium;
        } else {
            return styles.bad;
        }
    };

    _onPlayAudio = () => {
        if (this.props.onPlayAudio && _.isFunction(this.props.onPlayAudio)) {
            this.props.onPlayAudio();
        }
    };

    _onStopAudio = () => {
        if (this.props.onStopAudio && _.isFunction(this.props.onStopAudio)) {
            this.props.onStopAudio();
        }
    };

    _onStartRecordPress = () => {
        if (this.props.readonly) {
            return;
        }
        this.setState({
            currentState: 1, // 0 not start, 1 recording, 2 loading result, 3 result, 4 error in recognize
            prepareRecording: true,
            errorMessage: "",
            response: {},
        });
        //clear
        if (!this.props.enableSpeechRecognize && this.props.onTestResultCallBack && _.isFunction(this.props.onTestResultCallBack)) {
            this.props.onTestResultCallBack({ overriddenLetters: [] });
        }
        const filePath = generateTempWavFile(this.props.encodeFormat === 'mp3'); //every time you record, we use a new file and remember it
        this.setState({ lastGenerateWavFile: filePath });
        //set here to make sure you got the right path when there is more than one component here
        this.localVars.localSpeechService.setWavFilePath(filePath);
        this.localVars.localSpeechService.setEnableSpeechRecognize(false);
        const referenceTxt = this.props.language === "en" ? this.props.charArray.join(" ") : getReferenceText(this.props.charArray);
        this.localVars.localSpeechService.setReferenceText(referenceTxt);
        this.localVars.localSpeechService.setReferenceSyllables(this.props.pinyinArray);
        this.localVars.localSpeechService.setReferenceMarkText(this.props.language === "en" ? this.props.charArray.join(" ") : this.props.charArray.join(""));

        // 55秒自动结束录音(由于阿里云限制上传语音文件大小)
        if (this._recordingTimeout) {
            clearTimeout(this._recordingTimeout);
        }
        if (this.props.maxRecordLimit > 0) {
            this._recordingTimeout = setTimeout(() => {
                delete this._recordingTimeout;
                if (this.props.onRecordTimeout) {
                    this.props.onRecordTimeout();
                }
                this._onEndRecordPress();
            }, this.props.maxRecordLimit);
        }

        this.localVars.localSpeechService
            .startRecognize(() => {
                this.setState({ prepareRecording: false });
            })
            .then(responsez => {
                if (this._recordingTimeout) {
                    clearTimeout(this._recordingTimeout);
                    delete this._recordingTimeout;
                }

                if (this.props.enableSpeechRecognize) {
                    this.localVars.localSpeechService.getWavFilePath(filePath, file => {
                        const thenCallback = response => {
                            this.setState({ currentState: 3, prepareRecording: false, response: response });
                            if (this.props.onTestResultCallBack && _.isFunction(this.props.onTestResultCallBack)) {
                                //const { words } = this.props.data;
                                let returnArr = response.wordResultArray;

                                /*_.each(response.notPassedWordIndexDic, (value, key) => {
                                        returnArr.push({
                                            char: value.word,
                                            index: _.toInteger(key),
                                            accuracyScore: value.accuracyScore,
                                            errorType: value.errorType,
                                        });
                                    });

                                    //return array with not passed char*/

                                //return array with word result
                                this.props.onTestResultCallBack(returnArr);
                            }

                            if (this.props.onRawTestResultCallBack && _.isFunction(this.props.onRawTestResultCallBack)) {
                                this.props.onRawTestResultCallBack(response, file);
                            }
                        };
                        const catchCallBack = e => {
                            console.log(e);
                            this.setState({ currentState: 4, prepareRecording: false, errorMessage: e.message });
                            this._onRecognizeError(e);
                        };

                        if (this.props.onStartRecognize) {
                            this.props.onStartRecognize(file);
                        }
                        if (this.props.customRecognizeFileFunction && _.isFunction(this.props.customRecognizeFileFunction)) {
                            this.props
                                .customRecognizeFileFunction(file)
                                .then(thenCallback)
                                .catch(catchCallBack);
                        } else {
                            this.localVars.localSpeechService
                                .recognizeFile(file)
                                .then(thenCallback)
                                .catch(catchCallBack);
                        }
                    });
                } else {
                    if (this.props.onRecordEnd) {
                        this.localVars.localSpeechService.getWavFilePath(filePath, file => {
                            this.props.onRecordEnd(file);
                        });
                    }
                }
            })
            .catch(err => {
                if (this._recordingTimeout) {
                    clearTimeout(this._recordingTimeout);
                    delete this._recordingTimeout;
                }
                console.log(err);
                this.setState({ currentState: 4, prepareRecording: false, errorMessage: err.message });
                this._onRecordError(err);
            });

        if (this.props.onStartRecord && _.isFunction(this.props.onStartRecord)) {
            this.props.onStartRecord();
        }
    };

    _onEndRecordPress = () => {
        if (this.props.readonly) {
            return;
        }
        if (this._recordingTimeout) {
            clearTimeout(this._recordingTimeout);
            delete this._recordingTimeout;
        }
        this.localVars.localSpeechService.stopRecognize();
        this.setState({ currentState: 2, prepareRecording: false }, () => {
            if (this.props.onEndRecord && _.isFunction(this.props.onEndRecord)) {
                this.props.onEndRecord();
            }
        });
    };
    _onPlayMp3Press = () => {
        if (this.player) {
            if (this.props.onStartPlay) {
                this.props.onStartPlay();
            }

            this._getCurrentWavFilePath(file => {
                //console.log(file);
                //on ios same file seems have caching
                //use this to avoid this issue
                if (file !== "") {
                    this.setState({ lastWavPath: "", lastWavPathUri: "" }, () => {
                        if (file.indexOf("http") === 0) {
                            this.setState({ lastWavPath: file, lastWavPathUri: file }, () => {
                                this.player.seek(0);
                                this.setState({ paused: false });
                            });
                        } else {
                            localStorageFileHelper.getFile(file).then(fileX => {
                                this.setState({ lastWavPath: file, lastWavPathUri: fileX }, () => {
                                    this.player.seek(0);
                                    this.setState({ paused: false });
                                });
                            });
                        }
                    });
                }
            });
        }
    };
    _onStopMp3 = () => {
        if (this.props.onEndPlay) {
            this.props.onEndPlay();
        }

        this.setState({ paused: true }, () => {
            this.player.seek(0);
        });
    };

    _getCurrentWavFilePath = fn => {
        if (this.state.lastGenerateWavFile && !_.isEmpty(this.state.lastGenerateWavFile)) {
            this.localVars.localSpeechService.getWavFilePath(this.state.lastGenerateWavFile, file => {
                if (fn && _.isFunction(fn)) {
                    fn(file);
                }
            });
        } else {
            //播放指定录音
            if (this.props.initUserWavPath && !_.isEmpty(this.props.initUserWavPath)) {
                if (fn && _.isFunction(fn)) {
                    fn(Helper.convertToAbsoluteUrl(this.props.initUserWavPath));
                }
            } else {
                this.localVars.localSpeechService.getLastWavFilePath(file => {
                    if (fn && _.isFunction(fn)) {
                        fn(file);
                    }
                });
            }
        }
    };

    _onError = err => {
        if (this.props.onError && _.isFunction(this.props.onError)) {
            this.props.onError(err);
        }
    };

    _onRecordError = err => {
        if (err) {
            let error = err;
            let inVO = {
                errorMessage: 'SpeechTestBox:onRecordError:' + (error.message ? error.message : error.toString()),
                errorPage: '',
                errorTrace: error.stack ? error.stack.toString() : "",
            };
            ErrorHelper.addError(inVO);
        }

        if (this.props.onRecordError && _.isFunction(this.props.onRecordError)) {
            this.props.onRecordError(err);
        } else {
            this._onError(err);
        }
    };

    _onRecognizeError = err => {
        if (err) {
            let error = err;
            let inVO = {
                errorMessage: 'SpeechTestBox:onRecognizeError:' + (error.message ? error.message : error.toString()),
                errorPage: '',
                errorTrace: error.stack ? error.stack.toString() : "",
            };
            ErrorHelper.addError(inVO);
        }

        if (this.props.onRecognizeError && _.isFunction(this.props.onRecognizeError)) {
            this.props.onRecognizeError(err);
        } else {
            this._onError(err);
        }
    };

    /**
     * For outer use, get the path for upload or do something else
     *      Though they can combine there own path by the data send to this component
     *      Note this is a call back function
     *      if you set the wav file path, we will try to find the  one that match your wavFile path
     */
    getLastWavFilePath = fn => {
        this._getCurrentWavFilePath(fn);
    };
    /**
     * For outer use, get the path by path you set for upload or do something else, this can be  used in multi-record case
     *      Though they can combine there own path by the data send to this component
     *      Note this is a call back function
     */
    // getWavFilePath = (orgPath, fn) => {
    //     this.localVars.localSpeechService.getWavFilePath(orgPath, file => {
    //         if (fn && _.isFunction(fn)) {
    //             fn(file);
    //         }
    //     });
    // };

    /**
     * for outer use, incase if you need to do something with this SpeechRecognitionService
     * @returns {
     *  Object|{
     *      init: SpeechRecognition.init,
     *      setWavFilePath: SpeechRecognition.setWavFilePath,
     *      removeEventListener: removeEventListener,
     *      getHasWavFile: SpeechRecognition.getHasWavFile,
     *      setReferenceText: SpeechRecognition.setReferenceText,
     *      removeAllListeners: removeAllListeners,
     *      serviceTypeEnum: {Azure: number},
     *      getCurrentState: SpeechRecognition.getCurrentState,
     *      setEnableSpeechRecognize: SpeechRecognition.setEnableSpeechRecognize,
     *      getLastWavFilePath: SpeechRecognition.getLastWavFilePath,
     *      startRecognize: (function(): Promise<unknown>),
     *      addEventListener: addEventListener
     *      }
     * }
     */
    getSpeechRecognitionService = () => {
        return this.localVars.localSpeechService;
    };
}

const styles = {
    container: {
        paddingHorizontal: 10,
        height: 70,
        marginBottom: 15,
    },
    backgroundVideo: {
        // position: 'absolute',
        // top: 0,
        // left: 0,
        // bottom: 0,
        // right: 0,
        width: 1,
        height: 1,
    },
    playBtn: {
        backgroundColor: "#777",
        height: 48,
        width: 48,
        borderRadius: 50,
        justifyContent: "center",
        margin: 20,
    },
    playBtnDisabled: {
        backgroundColor: "#ccc",
        height: 48,
        width: 48,
        borderRadius: 50,
        justifyContent: "center",
        margin: 20,
    },
    recordBtn: {
        backgroundColor: "#66bb6a",
        height: 60,
        width: 60,
        borderRadius: 50,
        justifyContent: "center",
        margin: 20,
    },
    rerecordBtn: {
        backgroundColor: "#ffc000",
        height: 60,
        width: 60,
        borderRadius: 50,
        justifyContent: "center",
        marginLeft: 20,
        marginRight: 20,
        marginTop: 20,
        marginBottom: 8,
    },
    passed: {
        backgroundColor: "#66bb6a",
    },
    medium: {
        backgroundColor: "#ffb300",
    },
    bad: {
        backgroundColor: "#e53935",
    },
    score: {
        fontSize: 20,
        fontWeight: 700,
    },
    btnContainer: {
        flex: 1,
        alignItems: "center",
    },
};

SpeechTestBox.propTypes = {
    charArray: PropTypes.array,
    pinyinArray: PropTypes.array,
    onWordPress: PropTypes.func,
    onLetterPress: PropTypes.func,
    style: PropTypes.object,
    wordStyle: PropTypes.object,
    letterStyle: PropTypes.object,
    charVisible: PropTypes.bool,
    enableSpeechReview: PropTypes.bool,
    pinyinVisible: PropTypes.bool,
    recordingTitle: PropTypes.any,
    recordingBgColor: PropTypes.string,
    wavingLineColor: PropTypes.string,
    maxRecordLimit: PropTypes.number,
    onTestResultCallBack: PropTypes.func,
    customRecognizeFileFunction: PropTypes.func,
    onRawTestResultCallBack: PropTypes.func,
    onRecordEnd: PropTypes.func,
    onPlayAudio: PropTypes.func,
    onStopAudio: PropTypes.func,
    showLeftPlayButton: PropTypes.bool,
    showRecordButton: PropTypes.bool,
    readonly: PropTypes.bool,
    initUserWavPath: PropTypes.string,
    showRightPlayButton: PropTypes.bool,
    isConnected: PropTypes.bool,
    showScoreInside: PropTypes.bool,
    onStartRecord: PropTypes.func,
    onEndRecord: PropTypes.func,
    onStartPlay: PropTypes.func,
    onEndPlay: PropTypes.func,
    onError: PropTypes.func,
    initFailCallback: PropTypes.func,
    rejectPermissionCallback: PropTypes.func,
    enableSpeechRecognize: PropTypes.bool, // default disable the speech recognize, if disable , this component will be just a record/replay component
    serviceType: PropTypes.number, // default disable the speech recognize, if disable , this component will be just a record/replay component
};

SpeechTestBox.defaultProps = {
    charArray: [],
    pinyinArray: [],
    style: {}, // custom container style
    wordStyle: {},
    letterStyle: {},
    onWordPress: null,
    onLetterPress: null,
    enableSpeechReview: false,
    charVisible: true, // if show Chinese character
    pinyinVisible: true, // if show piyin of chinese character
    recordingTitle: null,
    recordingBgColor: "",
    wavingLineColor: "",
    maxRecordLimit: 0,
    onTestResultCallBack: null,
    showLeftPlayButton: true,
    showRecordButton: true,
    showRightPlayButton: true,
    showScoreInside: true,
    enableSpeechRecognize: false,
    //serviceType: AppConfig.SPEECH_RECOGNIZE_SERVICE_TYPE,
};

/**
 * helper for render previous next insert text
 * @param prevNextLetter
 * @param baseLetterStyle
 * @return {null}
 */
const renderPrevNextLetter = (prevNextLetter, baseLetterStyle) => {
    let prevLetter = null;
    if (prevNextLetter && prevNextLetter.length > 0) {
        const fakePreLetterItem = { char: `(${prevNextLetter})`, pinyin: "", colorKind: UnitStyle.blockAnswerInsertionFont };
        prevLetter = <Letter pinyinVisible={false} data={fakePreLetterItem} style={{ baseLetterStyle, ...fakePreLetterItem.colorKind }} />;
    }
    return prevLetter;
};

/**
 * Common Result Override Letter Helper
 * @param letter
 * @param index
 * @param pinyinVisible
 * @return {JSX.Element}
 */
const renderOverrideLetter = (letter, index, pinyinVisible, baseStyle) => {
    const baseLetterStyle = { ...letter.colorKind, ...baseStyle };

    return (
        <React.Fragment key={index}>
            {renderPrevNextLetter(letter.previousInsertedWord, baseLetterStyle)}
            <Letter pinyinVisible={pinyinVisible} data={letter} style={baseLetterStyle} />
            {renderPrevNextLetter(letter.nextInsertedWord, baseLetterStyle)}
        </React.Fragment>
    );
};

export default withTranslation(uid, { withRef: true })(SpeechTestBox);
export { renderPrevNextLetter, renderOverrideLetter, WavingLine, generateTempWavFile }; //export some common helper
